// extracted by mini-css-extract-plugin
export var sliderContainer = "ValuesSlider-module--sliderContainer--1Wdd2";
export var buttonContainer = "ValuesSlider-module--buttonContainer--zKQA3";
export var sliderWrapper = "ValuesSlider-module--sliderWrapper--GcyRE";
export var rightControlButton = "ValuesSlider-module--rightControlButton--2rGvi";
export var leftControlButton = "ValuesSlider-module--leftControlButton--2fZGV";
export var sliderText = "ValuesSlider-module--sliderText--2ZVy4";